import React from 'react';
import { useTranslation } from 'react-i18next';
import usePeopleCredit from '../../TabsComponent/People/hooks/UsePeopleCredit';
import usePeopleBusiness from '../../TabsComponent/People/hooks/UsePeopleBusiness';
import CreditPeopleSummaryContent from '../../TabsComponent/People/components/KybCreditReport/PeopleSummaryContent';
import CreditDirectorsContent from '../../TabsComponent/People/components/KybCreditReport/DirectorsContent';
import CreditShareHoldersContent from '../../TabsComponent/People/components/KybCreditReport/ShareHoldersContent';
import CreditPersonWithSignificantControlContent from '../../TabsComponent/People/components/KybCreditReport/PersonWithSignificantControlContent';
import BusinessPeopleSummaryContent from '../../TabsComponent/People/components/KybBusinessIdentity/PeopleSummaryContent';
import BusinessDirectorsContent from '../../TabsComponent/People/components/KybBusinessIdentity/DirectorsContent';
import BusinessShareHoldersContent from '../../TabsComponent/People/components/KybBusinessIdentity/ShareHoldersContent';
import BusinessOfficersContent from '../../TabsComponent/People/components/KybBusinessIdentity/OfficersContent';

const PEOPLE_I18N_BASE_PATH =
  'pages.private.KYBCompany.pages.companyDetails.subPages.people';

const CREDIT_I18N_BASE_PATH =
  'pages.private.KYBCompany.pages.companyDetails.subPages.people.creditReport';

const BUSINESS_I18N_BASE_PATH =
  'pages.private.KYBCompany.pages.companyDetails.subPages.people.businessIdentity';

const PeoplePrint = ({ peopleData, itemsToExport }) => {
  const { t: translate } = useTranslation();
  const credit = usePeopleCredit({ creditReportData: peopleData.creditReport });
  const business = usePeopleBusiness({
    businessIdentityData: peopleData.businessIdentity,
  });

  if (!itemsToExport.value) return <></>;

  return (
    <div className="to-print-company-details">
      <h2>{translate(`${PEOPLE_I18N_BASE_PATH}.title`, 'People')}</h2>

      {itemsToExport.items.creditReport.value && (
        <>
          <h3>Credit Report</h3>
          <CreditPeopleSummaryContent
            currentDirectorsLength={credit.currentDirectorsLength}
            previousDirectorsLength={credit.previousDirectorsLength}
            shareHoldersLength={credit.shareHoldersLength}
            activePersonsWithSignificantControlLength={
              credit.activePersonsWithSignificantControlLength
            }
          />
          {itemsToExport.items.creditReport.items.directors.value ? (
            <>
              <h4>
                {translate(`${CREDIT_I18N_BASE_PATH}.tabs.directors.title`, 'Directors')}
              </h4>
              <CreditDirectorsContent
                currentDirectorsLength={credit.currentDirectorsLength}
                previousDirectorsLength={credit.previousDirectorsLength}
                previousDirectorsList={credit.previousDirectorsList}
                creditReportData={peopleData.creditReport}
                collapsePrintSuffix={credit.collapsePrintSuffix}
                collapseOpened
              />
            </>
          ) : null}
          {itemsToExport.items.creditReport.items.shareholders.value ? (
            <>
              <h4>
                {translate(
                  `${CREDIT_I18N_BASE_PATH}.tabs.shareholders.title`,
                  'Shareholders'
                )}
              </h4>
              <CreditShareHoldersContent
                shareHoldersLength={credit.shareHoldersLength}
                shareholdersList={credit.shareholdersList}
              />
            </>
          ) : null}
          {itemsToExport.items.creditReport.items.pscUbo.value ? (
            <>
              <h4>
                {translate(
                  `${CREDIT_I18N_BASE_PATH}.tabs.personWithSignificantControl.title`,
                  'PSC/UBO'
                )}
              </h4>
              <CreditPersonWithSignificantControlContent
                creditReportData={peopleData.creditReport}
                activePersonsWithSignificantControlLength={
                  credit.activePersonsWithSignificantControlLength
                }
                active={credit.active}
                ceased={credit.ceased}
                total={credit.total}
                collapsePrintSuffix={credit.collapsePrintSuffix}
                collapseOpened
              />
            </>
          ) : null}
        </>
      )}

      {itemsToExport.items.businessIdentity.value && (
        <>
          <h4>Business identity</h4>
          <BusinessPeopleSummaryContent
            directors={business.directors}
            officers={business.officers}
            shareholders={business.shareholders}
          />
          {itemsToExport.items.businessIdentity.items.directors.value ? (
            <>
              <h4>
                {translate(
                  `${BUSINESS_I18N_BASE_PATH}.tabs.directors.title`,
                  'Directors'
                )}
              </h4>
              <BusinessDirectorsContent
                directors={business.directors}
                collapsePrintSuffix={credit.collapsePrintSuffix}
                collapseOpened
              />
            </>
          ) : null}
          {itemsToExport.items.businessIdentity.items.shareholders.value ? (
            <>
              <h4>
                {translate(
                  `${BUSINESS_I18N_BASE_PATH}.tabs.shareholders.title`,
                  'Shareholders'
                )}
              </h4>
              <BusinessShareHoldersContent
                shareholders={business.shareholders}
                collapsePrintSuffix={credit.collapsePrintSuffix}
                collapseOpened
              />
            </>
          ) : null}
          {itemsToExport.items.businessIdentity.items.officers.value ? (
            <>
              <h4>
                {translate(`${BUSINESS_I18N_BASE_PATH}.tabs.officers.title`, 'Officers')}
              </h4>
              <BusinessOfficersContent
                officers={business.officers}
                collapsePrintSuffix={credit.collapsePrintSuffix}
                collapseOpened
              />
            </>
          ) : null}
        </>
      )}
    </div>
  );
};

export default PeoplePrint;
